import React from 'react';
import {
  Box,
  Heading,
  Link,
  Image,
  Text,
  Divider,
  HStack,
  Tag,
  Wrap,
  WrapItem,
  SpaceProps,
  useColorModeValue,
  Container,
  VStack,
} from '@chakra-ui/react';

import {SCHEDULE} from "../data.json";
import { FaLink } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';

const BlogTags = (props) => {
  return (
    <HStack spacing={2} marginTop={props.marginTop}>
      {props.tags.map((tag) => {
        return (
          <Tag size={'md'} variant="solid" colorScheme="orange" key={tag}>
            {tag}
          </Tag>
        );
      })}
    </HStack>
  );
};

export const BlogAuthor = (props) => {
  return (
    <HStack marginTop="2" spacing="2" display="flex" alignItems="center">
      <Image
        borderRadius="full"
        boxSize="40px"
        src={props.image}
        alt={`Avatar of ${props.name}`}
      />
      <Text fontWeight="medium">{props.name}</Text>
      <Text>—</Text>
      <Text>{props.desi}</Text>
    </HStack>
  );
};

const EventsList = () => {
  return (
    <Container maxW="100%">
    {SCHEDULE.map((item) => {
        return (
            <Box
            marginTop="16"
            display="flex"
            flexDirection={{ base: 'column', sm: 'row' }}
            justifyContent="space-between">
            <Box
            display="flex"
            flex="1"
            marginRight="3"
            position="relative"
            alignItems="center">
            <Box
                width={{ base: '100%', sm: '85%' }}
                zIndex="2"
                marginLeft={{ base: '0', sm: '5%' }}
                marginTop="5%">
                <Link textDecoration="none" _hover={{ textDecoration: 'none' }}>
                <Image
                    borderRadius="lg"
                    src={item.image}
                    alt=""
                    objectFit="contain"
                    width="300px"
                />
                </Link>
            </Box>
            <Box zIndex="1" width="100%" position="absolute" height="100%">
                <Box
                bgGradient={"radial(orange.600 1px, transparent 1px)"}
                backgroundSize="20px 20px"
                opacity="0.4"
                height="100%"
                />
            </Box>
            </Box>
            <Box
            display="flex"
            flex="1"
            flexDirection="column"
            justifyContent="center"
            marginTop={{ base: '3', sm: '0' }}>
            <BlogTags tags={[item.tag]} />
            <Text
                as="p"
                marginTop="2"
                color={'gray.700'}
                fontSize="lg"
              >
                <span style={{fontWeight: "bold"}}>{item.label}</span> {item.isMark ? null : <Link href={item.link} fontSize="lg">Join <FiExternalLink style={{display: "inline"}} /></Link>}
            </Text>
            {item.description ? <Text
                as="p"
                marginTop="2"
                color={'gray.700'}
                fontSize="sm"
              >
                    {item.description}
            </Text> : null}
            <Text
                as="p"
                marginTop="2"
                color={'gray.700'}
                fontSize="lg"
                mb="5"
              >
                    {item.time}
            </Text>
            <Divider />
            {item.ppl.map((pplitem) => {
                return <BlogAuthor name={pplitem.name} desi={pplitem.desi} image={pplitem.image} /> 
            })}
            </Box>
        </Box>
        )
    })}
    </Container>
  );
};

export default EventsList;